import { GQLGENDER } from '@storyplay/core'

export const GENDER_SELECT_OPTIONS = [
  { label: '남자', value: GQLGENDER.Male },
  { label: '여자', value: GQLGENDER.Female },
]
